$(document).ready(function () {
  $(".slider").slick({
    dots: true,
    autoplay: true,
    autoplaySpeed: 4000,
  });

  $(".product-slider").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    asNavFor: ".product-slider-thumb",
  });

  $(".product-slider-thumb").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: ".product-slider",
    dots: false,
    focusOnSelect: true,
    arrows: true,
  });

  $(".contact-slider-content").slick({
    dots: true,
    autoplay: false,
    autoplaySpeed: 2000,
    arrows:true
  });

  $(".toggle-menu").on("click", function () {
    $(".menu-panel").toggleClass("active-menu");
    $(this).toggleClass("active-menu");
    $("body").toggleClass("overflow-hidden");
  });

  $(".faq-title").on("click", function () {
    $(this).next(".faq-content").toggleClass("item-active");
    $(".faq-title").not($(this)).removeClass("item-active");
    $(this).toggleClass("item-active");
    $(".faq-content").not($(this).next(".faq-content")).removeClass("item-active");
  });

  $(".form-title").on("click", function () {
    $(this).next(".form-content").toggleClass("item-active");
    $(".form-title").not($(this)).removeClass("item-active");
    $(this).toggleClass("item-active");
    $(".form-content").not($(this).next(".form-content")).removeClass("item-active");
  });

  $(".product-slider").on('afterChange', function(event, slick, currentSlide) {
    var slide = slick.$slides[currentSlide];
    if ($(slide).attr('loop') == 'loop') {
      $(slide).get(0).play()
    }
    });
});

$(window).scroll(function () {
  if (!$(".home-product-img") || $(".home-product-img").length == 0) return;
  var targetDivOffset = $(".home-product-img").offset().top;
  var scrollPosition = $(window).scrollTop();

  if (scrollPosition >= targetDivOffset - 300) {
    $(".home-product-img").addClass("run-animation");
  } else {
    $(".home-product-img").removeClass("run-animation");
  }

  if (scrollPosition >= targetDivOffset + 300) {
    $(".home-product-img").removeClass("run-animation");
  }
});

//attachment file
let attachedFiles = [];
$("#attachment").on("change", function () {
  const files = $(this)[0].files;
  for (let i = 0; i < files.length; i++) {
    const file = files[i];
    if (!attachedFiles.some((attachedFile) => attachedFile.name === file.name)) {
      attachedFiles.push(file);
      displayFile(file);
    }
  }
});
$("#fileList").on("click", ".remove-file", function () {
  const fileName = $(this).data("file-name");
  attachedFiles = attachedFiles.filter((file) => file.name !== fileName);
  $(this).parent().remove();
});
function displayFile(file) {
  const fileItem = $('<div class="file-item">');
  fileItem.append(`<span>${file.name}</span>`);
  fileItem.append(`<button class="remove-file ml-10 mb-20 px-12 py-8 text-white bg-blue radius-50 border-none" data-file-name="${file.name}">Effacer</button>`);
  $("#fileList").html(fileItem);
}

let attachedFilesSouci = [];
$("#attachmentSouci").on("change", function () {
  const files = $(this)[0].files;
  for (let i = 0; i < files.length; i++) {
    const file = files[i];
    if (!attachedFilesSouci.some((attachedFileSouci) => attachedFileSouci.name === file.name)) {
      attachedFilesSouci.push(file);
      displayFileSouci(file);
    }
  }
});
$("#fileList2").on("click", ".remove-file", function () {
  const fileName = $(this).data("file-name");
  attachedFiles = attachedFiles.filter((file) => file.name !== fileName);
  $(this).parent().remove();
});
function displayFileSouci(file) {
  const fileItem = $('<div class="file-item">');
  fileItem.append(`<span>${file.name}</span>`);
  fileItem.append(`<button class="remove-file ml-10 mb-20 px-12 py-8 text-white bg-blue radius-50 border-none" data-file-name="${file.name}">Effacer</button>`);
  $("#fileList2").html(fileItem);
}

//open modal
$("#submit-btn1700377656").on("click", function () {
  $("#popup-1").fadeIn();
  
});

$("#submit-btn1700379606").on("click", function () {
  $("#popup-2").fadeIn();
});


// Close the popup
$(".closeBtn").on("click", function () {
  $("#popup-1").fadeOut();
  $("#popup-2").fadeOut();
  $("#popup-footer").fadeOut()
  $('.remove-file').click()
});
